<app-base-send-sms
  formId="sendSmsForm"
  [childTagName]="tagName"
  [config]="baseSendSmsConfig"
  [form]="form"
  [loading]="loading"
  [fastSendLoading]="fastSendLoading"
  [campaignTitle]="model.title"
  [editModel]="formPageConfig.editData"
  (model)="getBaseSendSmsModel($event)"
  (privateNumber)="getPrivateNumber($event)"
  (onFastSend)="onFastSending()"
  (onSubmit)="onSubmit()"
  (onClosePage)="onClose()"
  [saveToCampaign]="model.saveToCampaign"
  (onSaveToCampaign)="onSaveToCampaign($event)"
>
  <fieldset class="tw-h-full" receivers>
    <legend class="tw-flex-center">
      <i class="mdi mdi-account-group tw-ml-2"></i>
      {{ pageVocabs + "legends.receivers" | translate }}
    </legend>

    <!------------------------- begin Edit Mode ---------------------------->
    <section *ngIf="formPageConfig.isEditMode">
      <nav
        ngbNav
        #nav="ngbNav"
        class="nav-tabs border-bottom"
        [destroyOnHide]="false"
      >
        <!-- receiversForAdd -->
        <ng-container ngbNavItem>
          <a ngbNavLink class="tw-flex-center">
            <i
              class="mdi mdi-account-multiple-plus text-success tw-mr-1 tw-text-3xl"
            ></i>
            <span class="tw-mt-1 tw-mr-2 text-dark">{{
              pageVocabs + "addReceivers" | translate
            }}</span>
          </a>

          <ng-template ngbNavContent>
            <!-- mobile Numbers widget -->
            <mobile-numbers-widget
              [title]="fields + 'receivers'"
              uniqId="receiversForAdd"
              [correctRows]="5"
              [wrongRows]="5"
              [importantHelp]="true"
              [maxMobileNumbers]="maxReceiversForAdd"
              [isTwilioNumber]="isTwilioNumber"
              responsiveClass="tw-w-full"
              [form]="form"
              groupName="receiversInformation"
              controlName="receiversForAdd"
              (mobileNumbers)="receiversForAdd = $event"
            >
            </mobile-numbers-widget>
          </ng-template>
        </ng-container>

        <!-- receiversForDelete -->
        <ng-container ngbNavItem>
          <a ngbNavLink class="tw-flex-center">
            <i
              class="mdi mdi-account-multiple-minus text-danger tw-mr-1 tw-text-3xl"
            ></i>
            <span class="tw-mt-1 tw-mr-2 text-dark">
              {{ pageVocabs + "removeReceivers" | translate }}</span
            >
          </a>
          <ng-template ngbNavContent>
            <!-- mobile Numbers widget -->
            <mobile-numbers-widget
              [title]="pageVocabs + 'missive'"
              uniqId="receiversForDelete"
              [correctRows]="5"
              [wrongRows]="5"
              [maxMobileNumbers]="maxReceiversForDelete"
              [isTwilioNumber]="isTwilioNumber"
              [importantHelp]="true"
              responsiveClass="tw-w-full"
              [form]="form"
              groupName="receiversInformation"
              controlName="receiversForDelete"
              (mobileNumbers)="receiversForDelete = $event"
            >
            </mobile-numbers-widget>
          </ng-template>
        </ng-container>
      </nav>
      <div [ngbNavOutlet]="nav" class="tw-mt-2"></div>
    </section>
    <!------------------------- end Edit Mode ---------------------------->

    <!-- mobile Numbers widget -->
    <ng-container *ngIf="!formPageConfig.isEditMode">
      <mobile-numbers-widget
        [title]="fields + 'receivers'"
        [uploadFileToServer]="isUploadFileToServer"
        uniqId="receivers"
        [correctRows]="5"
        [wrongRows]="5"
        responsiveClass="tw-w-full"
        [form]="form"
        [isTwilioNumber]="isTwilioNumber"
        groupName="receiversInformation"
        controlName="receivers"
        (mobileNumbers)="model.receivers = $event"
        (filePath)="model.path = $event"
        (isNeedUserConfirmation)="model.isNeedUserConfirmation = $event"
      >
      </mobile-numbers-widget>
    </ng-container>
  </fieldset>

  <!-- calcLoading -->
  <app-special-loading *ngIf="calcLoading" special-loading type="calculate">
  </app-special-loading>

  <!-- sendLoading -->
  <app-special-loading *ngIf="sendLoading" special-loading type="sending">
  </app-special-loading>
</app-base-send-sms>
